import { defineComponent as _defineComponent } from 'vue'
import { ref, PropType } from "vue"
import ContainerCard from "@/components/layout/CardContainer.vue"
import Footer from "@/components/layout/Footer.vue"
import {
  ApplicationTrack,
  BeginApplicationMutation,
  BeginApplicationMutationMutation,
  BeginApplicationMutationMutationVariables,
  ApplicantReferrer,
} from "@/gql"
import { useMutation } from "@/hooks/useMutation"
import { useNotification } from "@/hooks/useNotification"
import { APPLICANT_ID_KEY } from "@/components/apply/shared/constants"
import { SESSION_TOKEN_KEY } from "@/constants"
import ForgotPassword from "./ForgotPassword.vue"

type BeginApplicationValues = {
  email: string
  password: string
  referrer: ApplicantReferrer | null
  firstName?: string | null
  lastName?: string | null
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BeginApplication',
  props: {
  applicationTrack: {
    type: Object as PropType<ApplicationTrack | null>,
    required: true,
  },
},
  emits: ["goto-next"],
  setup(__props, { emit }) {

const props = __props


const { mutate } = useMutation()
const { addSuccess } = useNotification()
const isSubmitting = ref(false)
const showExtraFields = ref(false)
const showForgotPassword = ref(false)



const form = ref<BeginApplicationValues>({
  email: "",
  password: "",
  referrer: null,
  firstName: null,
  lastName: null,
})

const toggleForgotPassword = () => {
  showForgotPassword.value = !showForgotPassword.value
}

const referrerOptions = [
  {
    text: "LinkedIn",
    value: ApplicantReferrer.LinkedIn,
  },
  {
    text: "Instagram",
    value: ApplicantReferrer.Instagram,
  },
  {
    text: "Facebook",
    value: ApplicantReferrer.Facebook,
  },
  {
    text: "Twitter",
    value: ApplicantReferrer.Twitter,
  },
  {
    text: "WhatsApp",
    value: ApplicantReferrer.Whatsapp,
  },
  {
    text: "Tiktok",
    value: ApplicantReferrer.Tiktok,
  },
  {
    text: "Google Ad",
    value: ApplicantReferrer.GoogleAd,
  },
  {
    text: "News",
    value: ApplicantReferrer.News,
  },
  {
    text: "Friend/Colleague",
    value: ApplicantReferrer.FriendColleague,
  },
  {
    text: "Web Search",
    value: ApplicantReferrer.WebSearch,
  },
  {
    text: "Chancen",
    value: ApplicantReferrer.Chancen,
  },
  {
    text: "Other",
    value: ApplicantReferrer.Other,
  },
]

const onBeginApplication = async () => {
  if (!props.applicationTrack?.prn) return

  isSubmitting.value = true

  // Mutate
  const result = await mutate<
    BeginApplicationMutationMutation,
    BeginApplicationMutationMutationVariables
  >({
    mutation: BeginApplicationMutation,
    variables: {
      applicationTrackId: props.applicationTrack?.prn,
      applicantInput: form.value,
      newApplicant: showExtraFields.value,
    },
    handlePayloadErrors: true,
  })

  if (result?.data?.beginApplication.applicant?.id) {
    addSuccess("Login successful")

    //Please get rid of this in the next iteration
    localStorage.setItem(APPLICANT_ID_KEY, result.data.beginApplication.applicant.prn)
    localStorage.setItem(
      SESSION_TOKEN_KEY,
      `Bearer ${result.data.beginApplication.applicant.token}` as string
    )

    emit("goto-next")
  }

  isSubmitting.value = false
}

return { __sfc: true,emit, mutate, addSuccess, isSubmitting, showExtraFields, showForgotPassword, props, form, toggleForgotPassword, referrerOptions, onBeginApplication, ContainerCard, Footer, ForgotPassword }
}

})